import { config } from "./";

export const paths = {
    home: config.domainRelPathExt,
    offerItem: config.domainRelPath + "/:offerCategoryId/:offerItemId"
};